import React from 'react'
import { Chip, Menu, MenuItem } from '@mui/material'
import { KEY_APPS, getApplicationType } from '@common/applications'
import { spacing } from '../styling'
import { Gutters } from './Gutters'
import { Icon } from './Icon'

type Props = {
  device?: IDevice
  applicationTypes: IApplicationType[]
  selected?: IApplicationType['id']
  disabled?: boolean
  onSelect: (selected: IApplicationType) => void
}

export const ServiceFormApplications: React.FC<Props> = ({
  device,
  applicationTypes,
  selected,
  disabled,
  onSelect,
}) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const allowedApplications = applicationTypes.filter(a => getApplicationType(a.id).visibility(device))
  const keyApplications = allowedApplications.filter(a => KEY_APPS.has(a.id)).slice(0, 5)
  const otherApplications = allowedApplications.filter(a => !keyApplications.find(k => k.id === a.id))
  const otherSelected = otherApplications.find(a => a.id === selected)

  return (
    <Gutters
      top={null}
      bottom={null}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        // Target .MuiChip-root (0,2,0) to out-specify MUI's Chip base `margin: 0` (0,1,0),
        // which otherwise wins the tie now that this is sx instead of makeStyles.
        '& > .MuiChip-root': { margin: `${spacing.xxs}px` },
      }}
    >
      {keyApplications.map(t => (
        <Chip
          label={t.name}
          key={t.id}
          disabled={disabled}
          onClick={() => onSelect(t)}
          color={t.id === selected ? 'primary' : undefined}
          variant="filled"
        />
      ))}
      <Chip
        label={
          <>
            {otherSelected?.name || 'More'}
            <Icon name="chevron-down" size="sm" inline />
          </>
        }
        disabled={disabled}
        onClick={event => setAnchorEl(event.currentTarget)}
        color={otherSelected ? 'primary' : undefined}
        variant="filled"
      />
      <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        {otherApplications.map(a => (
          <MenuItem
            key={a.id}
            value={a.id}
            onClick={() => {
              onSelect(a)
              setAnchorEl(null)
            }}
            dense
          >
            {a.name}
          </MenuItem>
        ))}
      </Menu>
    </Gutters>
  )
}
